import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { createMetaVariables } from '@jane/bloom/resources/meta/createMetaVariables';
import { getMetaDescription } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { preloadImage } from '@jane/bloom/resources/meta/preloadImage';
import { getMetaTitle } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.$basename.($storeSlug).shop-all._index/route';

export const DEFAULT_CATEGORY_TITLE = `Shop {{ tabName }} cannabis products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}`;
export const DEFAULT_SHOP_ALL_TITLE = `Shop all products | {{ storeName }} Dispensary {{ storeCity }}, {{ storeStateAbbr }}`;
const DEFAULT_DESCRIPTION = `Visit {{ storeName }} dispensary in {{ storeCity }}, {{ storeStateAbbr }} and order {{ storeFulfillment }} cannabis online products for {{ storeType }}. Browse our online dispensary menu for flower, edibles, vape and more.`;

export const categoryRouteMeta: MetaFunction<typeof loader> = (args) => {
  const { customSEO, menuUrl, metaProps } = getRootLoaderData(args);
  const data = args.loaderData;

  const category = data?.category;

  // Match metaProps to available customSEO variables
  const metaVariables = createMetaVariables(metaProps, {
    tabName: category ? `${data?.customCategoryLabels?.[category]}` : 'all',
  });

  const aboveTheFoldImages = (data?.menuProductImgsAboveTheFold || [])
    .map((product) => product.imageSrcSet?.fallbackSrc)
    .filter((value, index, array) => array.indexOf(value) === index);

  return [
    getMetaTitle(
      category ? (customSEO?.category ?? {}) : (customSEO?.shopAll ?? {}),
      metaVariables,
      category ? DEFAULT_CATEGORY_TITLE : DEFAULT_SHOP_ALL_TITLE
    ),
    getMetaDescription(
      category ? (customSEO?.category ?? {}) : (customSEO?.shopAll ?? {}),
      metaVariables,
      DEFAULT_DESCRIPTION
    ),
    canonicalTag(args.location, menuUrl),
    ...aboveTheFoldImages.map(preloadImage),
    ...parentMeta(args),
  ];
};
